export const ProductType = {
  IProductService: Symbol("IProductService"),
};
